module.exports = __webpack_public_path__ + "img/72.d712b798.jpg";